import { extendTailwindMerge } from 'tailwind-merge';
import { fontSize } from '../fontSize.js';
export var twMerge = extendTailwindMerge({
    classGroups: {
        'font-size': [
            {
                text: Object.keys(fontSize)
            }
        ]
    }
});

//# sourceMappingURL=twMerge.js.map